import React from "react";

function DescriptionSkeletion() {
  return (
    <div className="relative -mx-4 min-h-screen w-[calc(100%+2rem)] overflow-hidden max-sm:-mx-3 max-sm:w-[calc(100%+1.5rem)]">
      <div className="mx-auto max-w-4xl px-6 pb-20 pt-6 max-sm:px-4">
        {/* back button */}
        <div className="h-10 w-10 animate-pulse rounded-full bg-white/[0.06]" />

        {/* centered hero */}
        <div className="mt-8 flex flex-col items-center">
          {/* artwork */}
          <div className="h-[260px] w-[260px] animate-pulse rounded-3xl bg-white/[0.06] max-sm:h-[200px] max-sm:w-[200px]" />

          {/* category chip */}
          <div className="mt-6 h-6 w-28 animate-pulse rounded-full bg-white/[0.06]" />

          {/* title */}
          <div className="mt-4 h-10 w-72 animate-pulse rounded-lg bg-white/[0.06] max-sm:w-56" />

          {/* actions */}
          <div className="mt-8 flex items-center gap-4">
            <div className="h-[52px] w-[160px] animate-pulse rounded-full bg-white/[0.06]" />
            <div className="h-12 w-12 animate-pulse rounded-full bg-white/[0.06]" />
          </div>
        </div>

        {/* about */}
        <div className="mx-auto mt-14 flex max-w-2xl flex-col items-center gap-2">
          <div className="mb-2 h-4 w-40 animate-pulse rounded bg-white/[0.06]" />
          <div className="h-4 w-full animate-pulse rounded bg-white/[0.06]" />
          <div className="h-4 w-[90%] animate-pulse rounded bg-white/[0.06]" />
          <div className="h-4 w-[80%] animate-pulse rounded bg-white/[0.06]" />
          <div className="h-4 w-[60%] animate-pulse rounded bg-white/[0.06]" />
        </div>
      </div>
    </div>
  );
}

export default DescriptionSkeletion;